export const BREAK_POINT_COLUMNS = {
  default: 6,
  2559: 5,
  2159: 4,
  1439: 3,
  1024: 2,
};
